import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteGLMLinkStatus, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

import { athleteGLMStatusKey } from './useAthleteGLMStatus';

interface LinkAthleteGLMArgs {
  athleteId: string;
  contactId: string;
}

/**
 * Link an athlete to an existing GLM contact (search-modal "Link" action).
 * On success invalidates the athlete detail + athlete list + GLM status caches.
 */
export default function useLinkAthleteGLM(): UseMutationResult<
  AxiosResponse<AthleteGLMLinkStatus>,
  AxiosError<ErrorMessage>,
  LinkAthleteGLMArgs
> {
  const queryClient = useQueryClient();

  return useMutation(
    ({ athleteId, contactId }: LinkAthleteGLMArgs) =>
      client.post<AthleteGLMLinkStatus>(`athletes/${athleteId}/glm/link/`, { contactId }),
    {
      onSuccess: (_data, { athleteId }) => {
        queryClient.invalidateQueries(athleteGLMStatusKey(athleteId));
        queryClient.invalidateQueries('athletes');
      },
    },
  );
}
